import encryptionService from '@/utils/axios-encryption'

export function getEncryptionKey() {
  let params = {
    baseURL: process.env.VUE_APP_TP_URL || process.env.VUE_APP_URL,
    url: '/tp/api/encrypt/key',
    method: 'get',
    headers: {
      'notEncrypted': true
    },
  }

  return encryptionService(params)
}